/**
 * Shop By Collection — responsive Swiper carousel.
 * Uses window.Swiper (theme loads swiper7.4.1.min.js).
 */

const SELECTOR_TRACK = '.js-shopByCollection';
const SELECTOR_PREV = '.swiper-button-prev';
const SELECTOR_NEXT = '.swiper-button-next';
// Swiper is deferred in theme.liquid, so it can land after this module runs.
const MAX_SWIPER_WAIT_FRAMES = 300;

class ShopByCollection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._waitFrame = null;
    this._waitFrameCount = 0;
    this._updateNavState = this._updateNavState.bind(this);
    this._sectionLoadHandler = this._onSectionChange.bind(this);
    this._sectionUnloadHandler = this._onSectionChange.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('shopify:section:load', this._sectionLoadHandler);
    document.addEventListener('shopify:section:unload', this._sectionUnloadHandler);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener('shopify:section:load', this._sectionLoadHandler);
    document.removeEventListener('shopify:section:unload', this._sectionUnloadHandler);
  }

  _onSectionChange(evt) {
    const target = evt && evt.target;
    if (!target || typeof target.querySelector !== 'function') return;
    if (target.querySelector('[data-component="shopByCollection"]')) {
      this.destroy();
      this.init();
    }
  }

  init() {
    if (!window.Swiper) {
      this._waitForSwiper();
      return;
    }

    const elTrack = this.querySelector(SELECTOR_TRACK);
    if (!elTrack) return;
    if (elTrack.classList.contains('swiper-initialized')) return;

    this.swiper = new window.Swiper(elTrack, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      slidesPerGroupAuto: true,
      navigation: {
        nextEl: this.querySelector(SELECTOR_NEXT),
        prevEl: this.querySelector(SELECTOR_PREV),
      },
      pagination: false,
      watchOverflow: true,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        1024: {
          spaceBetween: 12,
        },
      },
    });

    this.swiper.on('toEdge fromEdge lock unlock update resize', this._updateNavState);
    this._updateNavState();
  }

  _waitForSwiper() {
    if (this._waitFrame || this._waitFrameCount >= MAX_SWIPER_WAIT_FRAMES) return;

    this._waitFrame = requestAnimationFrame(() => {
      this._waitFrame = null;
      this._waitFrameCount += 1;
      if (this.isConnected) this.init();
    });
  }

  _updateNavState() {
    [this.querySelector(SELECTOR_PREV), this.querySelector(SELECTOR_NEXT)].forEach((button) => {
      if (!button) return;
      button.setAttribute('aria-disabled', button.classList.contains('swiper-button-disabled') ? 'true' : 'false');
    });
  }

  destroy() {
    if (this._waitFrame) {
      cancelAnimationFrame(this._waitFrame);
      this._waitFrame = null;
    }
    this._waitFrameCount = 0;

    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('shop-by-collection')) {
  customElements.define('shop-by-collection', ShopByCollection);
}
